module.exports = __webpack_public_path__ + "static/img/20014 (1).dc666e1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20014 (1).webp
// module id = HJrI
// module chunks = 14